import React from "react";
import { Boxes, Filter, Sparkles, Bell, TrendingUp } from "lucide-react";
import { useLang } from "../../i18n";
import { Reveal, SectionHeading } from "./shared";
import { TenderShowcase, PartnerShowcase, WorkspaceShowcase } from "./mocks";

const tenderIcons = [Boxes, Filter, Sparkles, Bell, TrendingUp];

export const TenderFeature = () => {
  const { t } = useLang();
  return (
    <section id="tenders" className="mx-auto max-w-[1180px] px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
      <Reveal><SectionHeading eyebrow={t.tender.eyebrow} title={t.tender.title} accent={t.tender.accent} subline={t.tender.subline} /></Reveal>
      <Reveal delay={0.06} className="mt-12"><TenderShowcase /></Reveal>
      <Reveal delay={0.1} className="mt-10">
        <div className="grid grid-cols-2 gap-4 border-t border-[var(--border)] pt-8 sm:grid-cols-3 lg:grid-cols-5">
          {t.tender.features.map((f, i) => {
            const Icon = tenderIcons[i];
            return (
              <div key={f.l} className="flex flex-col items-center gap-2 text-center">
                <span className="grid h-10 w-10 place-items-center rounded-xl bg-[var(--blue-soft)] text-[var(--blue)]"><Icon className="h-5 w-5" strokeWidth={1.6} /></span>
                <span className="text-[13px] font-medium text-[var(--ink)]">{f.l}</span>
              </div>
            );
          })}
        </div>
      </Reveal>
    </section>
  );
};

export const PartnerFeature = () => {
  const { t } = useLang();
  return (
    <section id="partners" className="border-y border-[var(--border)] section-wash">
      <div className="mx-auto max-w-[1180px] px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <Reveal><SectionHeading eyebrow={t.partner.eyebrow} title={t.partner.title} accent={t.partner.accent} subline={t.partner.subline} /></Reveal>
        <Reveal delay={0.06} className="mt-12"><PartnerShowcase /></Reveal>
      </div>
    </section>
  );
};

export const WorkspaceFeature = () => {
  const { t } = useLang();
  return (
    <section id="workspace" className="mx-auto max-w-[1180px] px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
      <Reveal><SectionHeading eyebrow={t.workspace.eyebrow} title={t.workspace.title} accent={t.workspace.accent} subline={t.workspace.subline} /></Reveal>
      <Reveal delay={0.06} className="mt-12"><WorkspaceShowcase /></Reveal>
      <Reveal delay={0.1} className="mt-10">
        <div className="grid grid-cols-1 gap-4 border-t border-[var(--border)] pt-8 sm:grid-cols-2 lg:grid-cols-4">
          {t.workspace.features.map((f) => (
            <div key={f.l}><div className="text-[14px] font-semibold text-[var(--ink)]">{f.l}</div><div className="mt-0.5 text-[12px] text-[var(--slate)]">{f.s}</div></div>
          ))}
        </div>
      </Reveal>
    </section>
  );
};
